import React from "react";
import ChatIcon from "./../../../graphics/svgs/chatIcon.svg";
import PrintIcon from "./../../../graphics/svgs/printIcon.svg";
import ThreeDotsHrz from "./../../../graphics/svgs/threeDotsHrz.svg";
import { Checkbox, Col, Row, Typography } from "antd";
import { formatDateInMMDDYYYY } from "../../../helpers/date";
import OrderDropDown from "../../Items/order-items/OrderDropDown";
import { orderStatusEnums } from "../../../helpers/enums";
const OrderHistoryTableRow: React.FC<IUserOrderHistoryTableRow> = ({
  activeBg,
  order,
}) => {
  const { demoGraphics, painProfile, createdAt, processingDetails } = order;
  const handleOpenPdf = (pdfUrl: string) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank"; // Opens in a new tab
    link.rel = "noopener noreferrer";
    link.click();
  };
  return (
    <Row
      style={{ background: activeBg }}
      gutter={[16, 16]}
      className="table-single-row-container"
    >
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-customer-phone">
          {painProfile.painRating}{" "}
          {formatDateInMMDDYYYY(new Date(createdAt), true)}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={7}>
        <Typography className="users-table-generic-label">
          {processingDetails.formulaAssigned !== null
            ? `${processingDetails.formulaAssigned?.activeIngredients},${processingDetails.formulaAssigned?.creamBase}`
            : "---"}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={5}>
        <Typography className="users-table-generic-label">
          {processingDetails.instructions || "---"}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          # {processingDetails.orderNumber}
        </Typography>

        <Typography className="order-prescribed-tag">
          {processingDetails.orderStatus}
        </Typography>
      </Col>
      <Col className="table-cell-hrz" span={4}>
        <img
          onClick={(e) => {
            if (
              order.processingDetails.orderStatus ===
                orderStatusEnums.ASSIGNED_RX &&
              order.processingDetails.shippingLabel !== null
            ) {
              handleOpenPdf(order.processingDetails.shippingLabel);
            }
          }}
          style={{ width: "25px", cursor: "pointer" }}
        />
        <Checkbox />
        <img src={ChatIcon} style={{ width: "25px", cursor: "pointer" }} />
        {/* <img src={ThreeDotsHrz} style={{ width: "25px", cursor: "pointer" }} /> */}
        <OrderDropDown order={order} />
      </Col>
    </Row>
  );
};

export default OrderHistoryTableRow;
